(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fedua-purchase-assurance"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'fedua:wishlist:v1';

    const readItems = () => {
      try {
        const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.filter((item) => item && item.id && item.title && item.url) : [];
      } catch (error) {
        return [];
      }
    };

    const writeItems = (items) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(items));
      } catch (error) {
        return false;
      }
      return true;
    };

    const productFromRoot = (root) => ({
      id: root.dataset.productId,
      title: root.dataset.productTitle,
      url: root.dataset.productUrl,
      image: root.dataset.productImage,
      price: root.dataset.productPrice,
    });

    const addBusinessDays = (sourceDate, days) => {
      const date = new Date(sourceDate);
      let remaining = Number(days) || 0;

      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        const weekday = date.getDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }

      return date;
    };

    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
          style: 'currency',
          currency: currency || 'EUR',
        }).format(cents / 100);
      } catch (error) {
        return `${(cents / 100).toFixed(2)} €`;
      }
    };

    const formatDeliveryDate = (date) => {
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || 'it-IT', {
          day: 'numeric',
          month: 'short',
        }).format(date);
      } catch (error) {
        return date.toLocaleDateString();
      }
    };

    const updateDeliveryWindow = (root) => {
      const output = root.querySelector('[data-fedua-delivery-window]');
      if (!output) return;

      const startDate = addBusinessDays(new Date(), root.dataset.feduaDeliveryMin);
      const endDate = addBusinessDays(new Date(), root.dataset.feduaDeliveryMax);
      output.textContent = root.dataset.feduaDeliveryTemplate
        .replace('__START__', formatDeliveryDate(startDate))
        .replace('__END__', formatDeliveryDate(endDate));
    };

    const renderShippingProgress = (root, cartTotal, cartItemCount = 0) => {
      const threshold = Number(root.dataset.feduaFreeShippingThreshold) || 0;
      if (threshold <= 0) return;

      const productPrice = Number(root.dataset.feduaProductPrice) || 0;
      const hasCartItems = Number(cartItemCount) > 0;
      const projectedTotal = hasCartItems ? Number(cartTotal || 0) : productPrice;
      const remaining = Math.max(threshold - projectedTotal, 0);
      const progress = Math.min(Math.round((projectedTotal / threshold) * 100), 100);
      const message = root.querySelector('[data-fedua-free-shipping-message]');
      const progressbar = root.querySelector('[data-fedua-free-shipping-progress]');
      const progressFill = progressbar?.querySelector('span');

      if (message) {
        message.textContent = remaining > 0
          ? (hasCartItems ? root.dataset.feduaCartShippingRemainingTemplate : root.dataset.feduaShippingRemainingTemplate).replace(
              '__AMOUNT__',
              formatMoney(remaining, root.dataset.feduaCurrency),
            )
          : (hasCartItems ? root.dataset.feduaCartShippingUnlocked : root.dataset.feduaShippingUnlocked);
      }

      progressbar?.setAttribute('aria-valuenow', String(progress));
      progressFill?.style.setProperty('--fedua-progress', `${progress}%`);
    };

    const shippingRequests = new WeakMap();

    const updateShippingProgress = async (root) => {
      const requestId = (shippingRequests.get(root) || 0) + 1;
      shippingRequests.set(root, requestId);
      try {
        const response = await fetch(root.dataset.feduaCartUrl, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
        });
        if (!response.ok) return;
        const cartState = await response.json();
        if (!root.isConnected || shippingRequests.get(root) !== requestId) return;
        renderShippingProgress(root, cartState.total_price, cartState.item_count);
      } catch (error) {
        return;
      }
    };

    const setStatus = (root, message) => {
      const status = root.querySelector('[data-fedua-wishlist-status]');
      if (!status) return;
      status.textContent = '';
      window.requestAnimationFrame(() => {
        status.textContent = message;
      });
    };

    const createWishlistItem = (root, item) => {
      const listItem = document.createElement('li');
      listItem.className = 'fedua-wishlist__item';

      if (item.image) {
        const image = document.createElement('img');
        image.className = 'fedua-wishlist__image';
        image.src = item.image;
        image.alt = '';
        image.loading = 'lazy';
        image.width = 48;
        image.height = 60;
        listItem.append(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'fedua-wishlist__image';
        placeholder.setAttribute('aria-hidden', 'true');
        listItem.append(placeholder);
      }

      const link = document.createElement('a');
      link.className = 'fedua-wishlist__link';
      link.href = item.url;
      link.textContent = item.title;

      if (item.price) {
        const price = document.createElement('span');
        price.className = 'fedua-wishlist__price';
        price.textContent = item.price;
        link.append(price);
      }

      listItem.append(link);

      const remove = document.createElement('button');
      remove.className = 'fedua-wishlist__remove';
      remove.type = 'button';
      remove.textContent = root.dataset.wishlistRemove;
      remove.addEventListener('click', () => {
        const nextItems = readItems().filter((savedItem) => savedItem.id !== item.id);
        if (writeItems(nextItems)) {
          setStatus(root, root.dataset.statusRemoved);
          updateAll();
        }
      });
      listItem.append(remove);

      return listItem;
    };

    const updateRoot = (root, items) => {
      const productId = root.dataset.productId;
      const isSaved = items.some((item) => item.id === productId);
      const toggle = root.querySelector('[data-fedua-wishlist-toggle]');
      const toggleLabel = root.querySelector('[data-fedua-wishlist-toggle-label]');
      const count = root.querySelector('[data-fedua-wishlist-count]');
      const empty = root.querySelector('[data-fedua-wishlist-empty]');
      const list = root.querySelector('[data-fedua-wishlist-items]');

      if (toggle) toggle.setAttribute('aria-pressed', String(isSaved));
      if (toggleLabel) toggleLabel.textContent = isSaved ? root.dataset.wishlistRemove : root.dataset.wishlistAdd;
      if (count) count.textContent = String(items.length);
      if (empty) empty.hidden = items.length > 0;

      if (list) {
        list.replaceChildren(...items.map((item) => createWishlistItem(root, item)));
      }
    };

    const updateAll = () => {
      const items = readItems();
      document.querySelectorAll('[data-fedua-purchase-assurance]').forEach((root) => updateRoot(root, items));
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-fedua-purchase-assurance]').forEach((root) => {
        if (root.dataset.feduaWishlistReady !== 'true') {
          root.dataset.feduaWishlistReady = 'true';

          const toggle = root.querySelector('[data-fedua-wishlist-toggle]');
          toggle?.addEventListener('click', () => {
            const items = readItems();
            const product = productFromRoot(root);
            const isSaved = items.some((item) => item.id === product.id);
            const nextItems = isSaved
              ? items.filter((item) => item.id !== product.id)
              : [...items, product];

            if (writeItems(nextItems)) {
              setStatus(root, isSaved ? root.dataset.statusRemoved : root.dataset.statusAdded);
              updateAll();
            }
          });
        }

        if (root.dataset.feduaConversionReady !== 'true') {
          root.dataset.feduaConversionReady = 'true';
          updateDeliveryWindow(root);
          updateShippingProgress(root);

        }
      });

      updateAll();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    const refreshShipping = () => {
      document.querySelectorAll('[data-fedua-purchase-assurance]').forEach(updateShippingProgress);
    };

    import('@shopify/events').then(({ StandardEvents }) => {
      document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
        Promise.resolve(event.promise).then(refreshShipping).catch(() => {});
      });
      document.addEventListener(StandardEvents.productSelect, (event) => {
        Promise.resolve(event.promise).then((result) => {
          const html = result?.detail?.html;
          if (!html) return;
          document.querySelectorAll('[data-fedua-purchase-assurance]').forEach((root) => {
            const updated = html.querySelector(
              `[data-fedua-purchase-assurance][data-product-id="${root.dataset.productId}"]`,
            );
            if (!updated) return;
            root.dataset.feduaProductPrice = updated.dataset.feduaProductPrice;
            root.dataset.productPrice = updated.dataset.productPrice;
            updateShippingProgress(root);
          });
        }).catch(() => {});
      });
    }).catch(() => {});
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey) updateAll();
    });
    window.addEventListener('pageshow', () => {
      document.querySelectorAll('[data-fedua-purchase-assurance]').forEach(updateShippingProgress);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
